var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/compose/components/autosuggest_account.tsx";
import React from 'react';
import Account from 'soapbox/components/account';
import { useAppSelector } from 'soapbox/hooks';
import { makeGetAccount } from 'soapbox/selectors';
const AutosuggestAccount = ({
  id
}) => {
  const getAccount = makeGetAccount();
  const account = useAppSelector(state => getAccount(state, id));
  if (!account) return null;
  return /*#__PURE__*/React.createElement(Account, {
    account: account,
    hideActions: true,
    showProfileHoverCard: false,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 10
    }
  });
};
export default AutosuggestAccount;